import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { CompensationLog_API } from "./CompensationLog_API";
import { AlertPopups } from "../../../components/AlertPopups";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import { Col, Form, Input, Label, Row } from "reactstrap";
import moment from "moment";
import { Routes } from "../../../configurations/config";
import { TableDateFormat } from "../../Dashboard/DashboardVariables";

function CompensationLogDetail() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const initialValues = {
		supervisorComments: "",
	};
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [offsiteRequestDetail, setOffsiteRequestDetail] = useState([]);
	const [formFields, setFormFields] = useState(initialValues);
	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		//get WorkType List
		axios
			.get(
				`${CompensationLog_API.GetDefaultEmployeeOffsiteRequestByID}/${id}`,
				{
					headers: header,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setOffsiteRequestDetail(data);
				}
			});
		setApiTokenHeader(header);
	}, []);

	const handleSubmit = () => {
		//aproving request
		reviewOffsiteWorkRequest(2);
	};
	const getImageByStatus = (status) => {
		switch (status.toLowerCase()) {
			case "approved":
				return (
					<img
						title="Approved"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/approved.jpg"
					/>
				);
			case "rejected":
				return (
					<img
						title="Rejected"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/rejected.png"
					/>
				);
			case "invalid":
				return (
					<img
						title="Invalid"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/invalid.png"
					/>
				);
			default:
				return (
					<img
						title="Pending"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/pending.png"
					/>
				);
		}
	};
	const reviewOffsiteWorkRequest = (approvalStatus) => {
		const formBody = {
			supervisorComments: formFields.supervisorComments,
			approvalStatus: approvalStatus,
		};

		axios
			.patch(
				`${CompensationLog_API.PatchEmployeeOffsiteHourRequests}/${id}`,
				formBody,
				{
					headers: apiTokenHeader,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Request Reviewed",
					});
					history.push(Routes.AdminCompensationLog);
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-2 pr-2 my-2">
							<Header
								title="Compensation Log Detail"
								headerBorder="true"
								navigateBack={() =>
									history.push(Routes.AdminCompensationLog)
								}
							/>

							<>
								{/* Form Container*/}
								<div className="formInfoContainer my-3">
									<div className="formInfoContainerHeader">
										<Label sm={12}>
											Offsite Work Details
										</Label>
									</div>
									<Formik
										enableReinitialize={true}
										initialValues={formFields}
										validateOnChange={true}
										onSubmit={() => {
											handleSubmit();
										}}
									>
										{({ errors, handleSubmit }) => (
											<Form>
												<Col>
													<Row className="py-2 px-4">
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Employee
																	Name
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<p className="formValueContainer">
																	{
																		offsiteRequestDetail.employeeName
																	}
																</p>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Request Type
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<p className="formValueContainer">
																{
																	offsiteRequestDetail.workType
																}
															</p>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Requested
																	Date
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<p className="formValueContainer">
																{moment(
																	offsiteRequestDetail.requestDate
																).format(
																	TableDateFormat
																)}
															</p>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Start Time
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<p className="formValueContainer">
																{moment(
																	offsiteRequestDetail.startTime,
																	"hh"
																).format("LT")}
															</p>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Work
																	Duration
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<p className="formValueContainer">
																{" "}
																{offsiteRequestDetail.workingHours +
																	" Hr " +
																	offsiteRequestDetail.workingMinutes +
																	" Min"}
															</p>
														</Col>

														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Reason for
																	Work
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<p className="formValueContainer">
																{
																	offsiteRequestDetail.employeeComments
																}
															</p>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Supervisor's
																	Comments
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<Row className="align-items-center">
																<Col lg={1}>
																	{offsiteRequestDetail.supStatus
																		? getImageByStatus(
																				offsiteRequestDetail.supStatus
																		  )
																		: null}
																</Col>
																<Col lg={9}>
																	<Input
																		type="textarea"
																		name="employeeComments"
																		value={
																			offsiteRequestDetail.supComments
																				? offsiteRequestDetail.supComments
																				: ""
																		}
																		className={`ml-1 supDesciptionBox ${
																			errors.supervisorComments
																				? "h-auto invalid"
																				: "h-auto"
																		}`}
																		onChange={(
																			event
																		) =>
																			setFormFields(
																				{
																					supervisorComments:
																						event
																							.target
																							.value,
																				}
																			)
																		}
																	/>
																</Col>
															</Row>
														</Col>
														<Col md={12} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Admin's
																	Comments
																</div>
															</div>
														</Col>
														<Col md={12} lg={3}>
															<Row className="align-items-center">
																<Col lg={1}>
																	{offsiteRequestDetail.adminStatus
																		? getImageByStatus(
																				offsiteRequestDetail.adminStatus
																		  )
																		: null}
																</Col>
																<Col lg={9}>
																	<Input
																		type="textarea"
																		name="employeeComments"
																		className="my-1 ml-1 supDesciptionBox"
																		value={
																			offsiteRequestDetail.adminComments
																				? offsiteRequestDetail.adminComments
																				: ""
																		}
																	/>
																</Col>
															</Row>
														</Col>
													</Row>
												</Col>
											</Form>
										)}
									</Formik>
								</div>
							</>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection for unauthorzed users
				);
			}}
		</UserConsumer>
	);
}

export default CompensationLogDetail;
